import * as React from 'react';
import { useTranslation } from "react-i18next";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { AutoComplete } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import CustomCommandCellGrid from '../ButtonComponentsPanel/CustomCellGridShips';
import { Link } from "react-router-dom";


export default function NavesListComponents() {
    const { t } = useTranslation();

    const sports = [
        'Baseball',
        'Basketball',
        'Cricket',
        'Field Hockey',
        'Football',
        'Table Tennis',
        'Tennis',
        'Volleyball'
    ];

    const [data, setData] = React.useState(sports);
    const [loading, setLoading] = React.useState(false);
    const [nombre, setNombre] = React.useState('');
    const [ciudad, setCiudad] = React.useState('');
    const [vista, setVista] = React.useState('');
    const [integrador, setIntegrador] = React.useState('');

    const timeout = React.useRef();

    const handleChange = (setter) => (event) => {
        const value = event.target.value;
        const filterData = (value) => {
            const filter = {
                value: value,
                operator: 'startswith',
                ignoreCase: true,
            };
            return filterBy(sports, filter);
        };

        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            setData(filterData(value));
            setLoading(false);
        }, 400);

        setter(value);
        setLoading(true);
    };

    const initialData = [
        {
            ProductID: 1,
            ProductName: 'Naves A',
            FirstOrderedOn: new Date(),
            UnitsInStock: 10,
            Discontinued: false,
        },
        {
            ProductID: 2,
            ProductName: 'Naves B',
            FirstOrderedOn: new Date(),
            UnitsInStock: 5,
            Discontinued: true,
        },
    ];

    const [gridData] = React.useState(initialData);
    const CommandCell = (props) => (
        <CustomCommandCellGrid {...props}
            remove={(item) => console.log('Eliminar:', item)}
        />
    );

    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-sm-12 col-md-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">

                                <div className="d-flex flex-column flex-md-row align-items-center gap-3 w-100 justify-content-md-start">

                                    <div className="text-center text-md-start flex-fill" style={{ maxWidth: '160px' }}>
                                        <FloatingLabel label={'Nombre'} editorId="nombreInput" editorValue={nombre}>
                                            <AutoComplete
                                                id="nombreInput"
                                                data={data}
                                                value={nombre}
                                                onChange={handleChange(setNombre)}
                                                loading={loading}
                                                style={{ width: '100%' }}
                                            />
                                        </FloatingLabel>
                                    </div>

                                    <div className="text-center text-md-start flex-fill" style={{ maxWidth: '160px' }}>
                                        <FloatingLabel label={'Ciudad'} editorId="ciudadInput" editorValue={ciudad}>
                                            <AutoComplete
                                                id="ciudadInput"
                                                data={data}
                                                value={ciudad}
                                                onChange={handleChange(setCiudad)}
                                                loading={loading}
                                                style={{ width: '100%' }}
                                            />
                                        </FloatingLabel>
                                    </div>

                                    <div className="text-center text-md-start flex-fill" style={{ maxWidth: '160px' }}>
                                        <FloatingLabel label={'Ciudad'} editorId="ciudadVista" editorValue={vista}>
                                            <DropDownList
                                                id="ciudadVista"
                                                style={{ width: '100%' }}
                                                data={sports}
                                                value={vista}
                                                onChange={(e) => setVista(e.target.value)}
                                                defaultItem="Selecciona ciudad"
                                            />
                                        </FloatingLabel>
                                    </div>

                                    <div className="text-center text-md-start flex-fill" style={{ maxWidth: '400px' }}>
                                        <FloatingLabel label={'Integrador'} editorId="ciudadIntegrador" editorValue={integrador}>
                                            <DropDownList
                                                id="ciudadIntegrador"
                                                style={{ width: '100%' }}
                                                data={sports}
                                                value={integrador}
                                                onChange={(e) => setIntegrador(e.target.value)}
                                                defaultItem="Selecciona integrador"
                                            />
                                        </FloatingLabel>
                                    </div>

                                    <div className="text-center text-md-start align-self-md-end d-flex gap-2" style={{ minWidth: '200px' }}>
                                        <Button type="button" className="flex-fill">
                                            Filtrar
                                        </Button>
                                        <Button type="button" className="flex-fill">
                                            Limpiar
                                        </Button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                    <br />

                    <Grid
                        style={{ height: '420px' }}
                        data={gridData}
                    >
                        <GridToolbar>
                            <Link to="/CreateNaves">
                                <Button type="button">
                                    {t("Global_Label_Text_Create")}
                                </Button>
                            </Link>
                        </GridToolbar>
                        <Column cell={CommandCell} width="100px" />
                        <Column field="ProductID" title="Id" width="50px" editable={false} />
                        <Column field="ProductName" title="Product Name" width="200px" />
                        <Column field="FirstOrderedOn" title="First Ordered" editor="date" format="{0:d}" width="150px" />
                        <Column field="UnitsInStock" title="Units" width="120px" editor="numeric" />
                        <Column field="Discontinued" title="Discontinued" editor="boolean" />
                    </Grid>


                </div>
            </div>

        </div>
    );
}